@if (loading) {
<div class="flex justify-content-center align-items-center h-full">
    <p-progressSpinner></p-progressSpinner>
</div>
} @else {
<div class="flex flex-column h-full">
    <!-- Barre de recherche -->
    @if (clients.length > 0) {
    <div class="search-container mb-4">
        <p-iconField iconPosition="left">
            <p-inputIcon class="pi pi-search" />
            <input pInputText type="text" [(ngModel)]="searchQuery" placeholder="Rechercher une organisation..."
                class="w-full" [pAutoFocus]="true" />
        </p-iconField>
    </div>
    }

    <!-- Liste des organisations en cards -->
    <div class="organizations-grid">
        @for (client of filteredClients; track client.id) {
        <div>
            <app-organization-card [accountantMode]="accountantMode" [client]="client"
            (activationClicked)="onActivationClicked($event)"
                (organizationClicked)="onOrganizationClick($event)"></app-organization-card>
        </div>
        }
        @if (showAddClient) {
        <div>
            <app-add-organization-card (addOrganizationClicked)="addOrganizationClicked.emit()"></app-add-organization-card>
        </div>
        }
    </div>

    @if (filteredClients.length === 0 && searchQuery) {
    <div class="text-center text-600 mt-4">
        Aucune organisation ne correspond à votre recherche.
    </div>
    }
</div>
}